import { render, staticRenderFns } from "./OldUpload.vue?vue&type=template&id=6b77d6f5"
import script from "./OldUpload.vue?vue&type=script&lang=js"
export * from "./OldUpload.vue?vue&type=script&lang=js"
import style0 from "./OldUpload.vue?vue&type=style&index=0&id=6b77d6f5&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports